module.exports = __webpack_public_path__ + "media/customizations/colton/back-9f1d69c8221e987867092b82707d8d55.jpg";